const authors = [
{
id: "jane-whimsey",
name: "Jane Whimsey",
icon: "",
about: "I am Jane Whimsey, and I hold a grudge."
},
{
id: "marvin-rider",
name: "Marvin Rider",
icon: "",
about: "Marvin is a chemical drenched culture warrior, ready to take up arms. He seeks to shine a white-hot light on the human condition at is best, its worst, and at its weirdest. Jaded to the core, his optimism comes across with dark and sometimes nasty humor."
},
{
id: "mgc-traveler",
name: "MGC Traveler",
icon: "",
about: "MGC Traveler is a gentler, more thoughtful voice. He seeks the deeper meaning of Life, the Universe, and Everything."
},
{
id: "jason-satyr",
name: "Jason Satyr",
icon: "",
about: "Welcome to your new source of edgy to obnoxious satire about the modern age."
},
{
id: "the-apostate",
name: "The Apostate",
icon: "",
about: "The Apostate hates religion and seeks to undermine it at every turn. This once devout fanatic now has the ultimate goal of ending of all religion. The Apostate pulls no punches and spares no one."
},
{
id: "alix-burn",
name: "Alix Burn",
icon: "",
about: "",
},
{
id: "rick-friction",
name: "Rick Friction",
icon: "",
about: "",
},
{
id: "anonymous-one",
name: "Letters to the Editor",
icon: "",
about: "",
},
{
id: "news-grinder",
name: "Newsgrinder",
icon: "",
about: "",
},
{
id: "daily-meme",
name: "Meme of the Day",
icon: "",
about: "",
},
]
export default authors;
